// Available formats for download.
enum ImageFormat {
  SVG = 'image/svg+xml',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}

export default ImageFormat
